import React from "react";
import { StatCard } from "@/components/ui";
import { IndianRupee, Users, CheckCircle2, AlertTriangle, FileText, Wallet, TrendingUp, Scale, Calculator, Landmark, Receipt, Banknote } from "lucide-react";
import { ACCOUNT_STAT_TITLES } from "@/constants/globalConstants";

const fmt = (v) => new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);

export const AccountsStats = ({ stats = {}, activeTab = 'accounts_master' }) => {
  const {
    totalReceived,
    pendingBalance,
    fullyPaid,
    totalExpenses,
    statusBreakdown,
    sourceBreakdown
  } = stats;

  /* Developer : Nithin
  Date : 26-06-2026
  changes: separated material expenses and received amount stat cards to have context-specific labels */
  if (activeTab === 'material_expenses') {
    return (
      <div className="space-y-4 relative group/stats">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <StatCard
            variant="luxury"
            title="Total no.of projects"
            value={stats.totalProjects || 0}
            sub="Unique projects"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<FileText className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Total material Expenses"
            value={`₹${fmt(stats.totalMaterialExpenses || 0)}`}
            sub="Overall material expenses"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<IndianRupee className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Avg in each project cost"
            value={`₹${fmt(stats.avgProjectCost || 0)}`}
            sub="Average cost per project"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<CheckCircle2 className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Total Items"
            value={stats.totalItems || 0}
            sub="Total items requested"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<Wallet className="w-10 h-10" strokeWidth={2} />}
          />
        </div>
      </div>
    );
  }

  if (activeTab === 'received_amount') {
    return (
      <div className="space-y-4 relative group/stats">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <StatCard
            variant="luxury"
            title="Total Transactions"
            value={stats.count || 0}
            sub="Total receipts tracked"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<Receipt className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Total Amount Received"
            value={`₹${fmt(stats.requestedTotal || 0)}`}
            sub="Overall amount received"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<IndianRupee className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Total No of Clients"
            value={stats.uniqueClients || 0}
            sub="Unique clients billed"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<Users className="w-10 h-10" strokeWidth={2} />}
          />
          <StatCard
            variant="luxury"
            title="Balance Amount"
            value={`₹${fmt(stats.pendingBalance || 0)}`}
            sub="Total pending balance"
            topColor="border-t-[#C91D25]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<Scale className="w-10 h-10" strokeWidth={2} />}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 relative group/stats">

      {/* Developer : Nithin
      Date : 26-06-2026
      changes: updated stat card titles and icons for pipeline, expenses, received, balance */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          variant="luxury"
          title="Total Pipeline Value"
          value={`₹${fmt(stats.budget || 0)}`}
          sub="Combined project value"
          topColor="border-t-[#C91D25]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<IndianRupee className="w-10 h-10" strokeWidth={2} />}
        />

        <StatCard
          variant="luxury"
          title="Total Expenses"
          value={`₹${fmt(totalExpenses || 0)}`}
          sub="Overall project expenses"
          topColor="border-t-[#C91D25]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<Calculator className="w-10 h-10" strokeWidth={2} />}
        />

        <StatCard
          variant="luxury"
          title="Total Received"
          value={`₹${fmt(totalReceived || 0)}`}
          sub="Overall payments received"
          topColor="border-t-[#C91D25]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<Wallet className="w-10 h-10" strokeWidth={2} />}
        />

        <StatCard
          variant="luxury"
          title="Balance"
          value={`₹${fmt(pendingBalance || 0)}`}
          sub="Outstanding balance"
          topColor="border-t-[#C91D25]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<Landmark className="w-10 h-10" strokeWidth={2} />}
        />
      </div>
    </div>
  );
};




